import React, { useEffect, useRef, useState, useContext } from "react";
import EmptyImg from "../Assets/Images/avatar.png";
import { ButtonContainer } from "../Components/Shared/ButtonComponent";
import EditProfile from "../Components/Laundry/EditProfile";
import { useNavigate } from "react-router-dom";
import TailoringOrders from "../Components/Laundry/TailoringOrders";
import styles from "../Styles/TailoringHistory.module.css";
import TailoringOrderCard from "../Components/ProfileCard/TailoringOrderCard";
import useTailoring from "../hooks/useTailoring";
import { UserContext } from "../context/userContext";

const TailoringHistory = ({ editProfile, setEditProfile }) => {
  const [orderType, setOrderType] = useState("");
  const [profilePic, setProfilePic] = useState(null);
  const [tailoringOrders, setTailoringOrders] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [orderArr, setOrderArr] = useState([]);

  const { handleGetOrderDetails } = useTailoring();
  const { isLoggedIn, profileData: user } = useContext(UserContext);

  const ImageRef = useRef();

  useEffect(() => {
    if (profilePic == null) {
      return;
    }

    const reader = new FileReader();
    reader.addEventListener("load", (e) => {
      ImageRef.current.src = e.target.result;
    });
    reader.readAsDataURL(profilePic);
  }, [profilePic]);

  const navigate = useNavigate();

  const handleSelect = (e) => {
    setOrderType(e.target.value);
    if (e.target.value === "laundry") {
      navigate("/laundry/laundryhistory");
    } else if (e.target.value === "tailoring") {
      navigate("/tailoring/tailoringhistory");
    }
  };

  useEffect(() => {
    handleGetOrderDetails().then((res) => {
      setOrderArr(res?.data?.tailoring_order);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        className={`col-12 laundryhistory ${styles.tailoringHistoryContainer}`}
      >
        <div>
          <p className="profiles">Profile</p>
          <div className="profile_img bg-white">
            {user?.image_url === "" || user?.image_url === undefined ? (
              <img
                alt=""
                src={EmptyImg}
                className="w-100"
                style={{ objectFit: "contain" }}
              />
            ) : (
              <img
                alt=""
                src={user?.image_url}
                className="w-100"
                style={{ objectFit: "contain" }}
              />
            )}
          </div>

          <div className="profilename">
            <p className="text-capitalize">
              {isLoggedIn ? user.first_name : "First "}{" "}
              {isLoggedIn ? user.last_name : "Name"}
            </p>
            <p>{isLoggedIn ? user.email : "Email Address"}</p>
            <div>
              <ButtonContainer onClick={() => setEditProfile(true)}>
                Edit Profile
              </ButtonContainer>
            </div>
          </div>
        </div>
        <div>
          <span>
            <span>
              <span className="">
                <select
                  value={orderType}
                  onChange={handleSelect}
                  className="form-select laundry-form form-select-lg  shadow-none select-order"
                  aria-label=".form-select-lg example"
                >
                  <option value="tailoring"> Tailoring History</option>
                  <option value="laundry"> Laundry History</option>
                </select>
              </span>
            </span>
          </span>
          {!orderArr && (
            <div>
              <div className="nullContainer">
                <div>
                  <p>It feels empty here.</p>
                  <p>You are yet to make any order</p>

                  <div>
                    <ButtonContainer
                      onClick={() => navigate("/tailoring/femalestyle")}
                    >
                      Make an order now
                    </ButtonContainer>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="historyDiv">
            {orderArr?.map((item, index) => (
              <TailoringOrderCard
                {...{
                  setSelectedOrder,
                  setTailoringOrders,
                  item,
                  index,
                  selectedOrder,
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <EditProfile {...{ editProfile, setEditProfile, setProfilePic }} />
      <TailoringOrders
        {...{
          tailoringOrders,
          setTailoringOrders,
          orderArr,
          setOrderArr,
          selectedOrder,
        }}
      />
    </>
  );
};

export default TailoringHistory;
